// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"4":"ec96b8e6","139":"fb18625c"}[chunkId] + ".js";
};